<ng-template #changePasswordTemplate>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-change-password.title-change-password' | locTranslate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeEditor()"></button>
    </div>
    <div class="modal-body PGChangePassword">
        <p class="text-muted mb-3">
            {{ 'pg-change-password.subtitle-change-password' | locTranslate}}
        </p>

        <div class="form-group">
            <label>
                <b>{{ 'pg-change-password.input-new-password' | locTranslate }}</b>
            </label>
            <input type="password" class="form-control" [(ngModel)]="changePasswordNew" placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;" (ngModelChange)="onChangePasswordNewChange()" (keyup)="onChangePasswordKeyUp($event)"/>
        </div>
        <div class="form-group form-text">
            @if (changePasswordErrorLength) {
                <div class="text-danger">{{ 'pg-change-password.change-password-error-length' | locTranslate }}</div>
            }
            @if (changePasswordErrorFormat) {
                <div class="text-danger">{{ 'pg-change-password.change-password-error-format' | locTranslate }}</div>
            }
        </div>
        <div class="form-group">
            <label>
                <b>{{ 'pg-change-password.input-new-password-confirm' | locTranslate }}</b>
            </label>
            <input type="password" class="form-control" [(ngModel)]="changePasswordNewConfirm" placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;" (ngModelChange)="onChangePasswordNewChange()" (keyup)="onChangePasswordKeyUp($event)"/>
        </div>
        <div class="form-group form-text">
            @if (changePasswordErrorConfirm) {
                <div class="text-danger">{{ 'pg-change-password.change-password-error-confirm' | locTranslate }}</div>
            }
        </div>
        <button class="btn btn-primary btn-block" [disabled]="!canChangePassword()" (click)="doChangePassword()">
            <i class="fa-regular fa-sign-in-alt"></i>
            <span>{{ 'pg-change-password.button-change-password' | locTranslate }}</span>
        </button>
    </div>
</ng-template>
